import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Lists from '../views/Lists.vue'
import About from '../views/About.vue'
import Meeting from '../views/Meeting.vue'
import Settings from '../components/Settings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/lists',
    name: 'Lists',
    component: Lists
  }, {
    path: '/lists/:id',
    name: 'List',
    component: Home
  }, {
    path: '/lists/:id/:contact_id',
    name: 'Contact',
    component: Home
  }, {
    path: '/about',
    name: 'About',
    component: About
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    props: { set_tab: 0 }
  }, {
    path: '/settings/twilio',
    name: 'twilio_settings',
    component: Settings,
    props: { set_tab: 0 }
  }, {
    path: '/settings/phone_numbers',
    name: 'phone_number_settings',
    component: Settings,
    props: { set_tab: 1 }
  }, {
    path: '/settings/phone',
    name: 'phone_settings',
    component: Settings,
    props: { set_tab: 2 }
  }, {
    path: '/settings/audio_files',
    name: 'audio_files',
    component: Settings,
    props: { set_tab: 3 }
  }, {
    path: '/meet',
    name: 'meeting',
    component: Meeting
  }

]

const router = new VueRouter({
  routes
})

export default router
